import { Injectable } from '@angular/core';
import { 
  CanActivate, 
  ActivatedRouteSnapshot, 
  RouterStateSnapshot, 
  Router,
  UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  
  constructor(private authService: AuthService, private router: Router) {}
  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    
    // Check both parent and child route data
    if (route.data['skipAuthGuard'] || route.firstChild?.data['skipAuthGuard']) {
      return true;
    }
    
    // Check if user is logged in
    const isLoggedIn = this.authService.checkAuthState();
    
    if (isLoggedIn) {
      return true;
    }
    
    // If not logged in, redirect to login page with return url
    this.router.navigate(['/auth/login'], { 
      queryParams: { returnUrl: state.url }
    });
    
    return false;
  }
} 